// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Initialize language from localStorage or default to Thai
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('-language');
    return savedLanguage || 'TH';
  });

  // Save language preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('-language', language);
  }, [language]);

  const changeLanguage = (newLanguage) => {
    if (['TH', 'EN', 'CN'].includes(newLanguage)) {
      setLanguage(newLanguage);
    }
  };

  const value = {
    language,
    changeLanguage,
    // Helper function to get current language name
    getLanguageName: () => {
      const names = {
        TH: 'ไทย',
        EN: 'English',
        CN: '中文'
      };
      return names[language];
    }
  };
  console.log('[LANGUAGE CONTEXT] Loaded language:', language);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;